var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
export class ActorMedia {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get allSoundsFiles() {
        return this.actor.actorAttachedTraits.allAttachedTraitsOfKey('sound').map((at) => at.trait.value);
    }
    get allAtttachedSounds() {
        return this.actor.actorAttachedTraits.allAttachedTraitsOfKey('sound');
    }
    get allAtttachedVideos() {
        return this.actor.actorAttachedTraits.allAttachedTraitsOfKey('video');
    }
    get allAttachedMedia() {
        return [...this.allAtttachedSounds, ...this.allAtttachedVideos];
    }
    get ownMediaContext() {
        return this.allAttachedMedia.reduce((returnObj, item) => {
            if (!item.trait.value)
                return returnObj;
            const medFile = item.trait.value;
            if (!returnObj[medFile.mediumLabel]) {
                returnObj[medFile.mediumLabel] = item; // without _auto
            }
            return returnObj;
        }, {});
    }
}
__decorate([
    sortedSet
], ActorMedia.prototype, "allSoundsFiles", null);
__decorate([
    sortedSet
], ActorMedia.prototype, "allAtttachedSounds", null);
__decorate([
    sortedSet
], ActorMedia.prototype, "allAtttachedVideos", null);
__decorate([
    sortedSet
], ActorMedia.prototype, "allAttachedMedia", null);
__decorate([
    computed
], ActorMedia.prototype, "ownMediaContext", null);
